module.exports = __webpack_public_path__ + "images/cfcedbf51485f455901143ab566e9659.png";